import { SxProps } from '@mui/material';

export const navigationContainer: SxProps = {
  borderRight: '3px solid grey',
};
